import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

export default {
    async EncabezadoReporte(vm) {
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("aiclave", datos.aiclave);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}RLV/ReporteEncabezado`, formData);
        return response.data[0];
    },
    async DatosDetalle(vm) {
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("aiclave", datos.aiclave);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}RLV/DetalleGeneral`, datosReporte);
        return response.data;
    },
    async AvePrevMovimientos(vm, tipo, apartado) {
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("aiclave", datos.aiclave);
        datosReporte.append("tipo", tipo);
        datosReporte.append("apartado", apartado);
        return vm.axios.post(`${vm.domain.domainNameForApi}ExpJur/AvePrevMovimientos`, datosReporte).then(response => response.data);
    },
    async DatosAsistencia(vm, tipo, apartado) {
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("aiclave", datos.aiclave);
        datosReporte.append("tipo", tipo);
        datosReporte.append("apartado", apartado);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}ExpJur/DatosAsistencia`, datosReporte)
        return response.data.encabezados;
    }
}